import { motion } from 'framer-motion'

interface FloatingShapeProps {
  delay?: number
  duration?: number
  size?: number
  x?: number
  y?: number
  color?: string
}

export default function FloatingShapes() {
  const shapes: FloatingShapeProps[] = [
    { delay: 0, duration: 20, size: 200, x: 10, y: 20, color: 'vibrant-cyan' },
    { delay: 2, duration: 25, size: 300, x: 80, y: 60, color: 'vibrant-purple' },
    { delay: 4, duration: 30, size: 150, x: 30, y: 80, color: 'vibrant-pink' },
    { delay: 1, duration: 22, size: 250, x: 70, y: 30, color: 'vibrant-yellow' },
    { delay: 3, duration: 28, size: 180, x: 50, y: 70, color: 'vibrant-lime' },
  ]

  return (
    <div className="absolute inset-0 pointer-events-none overflow-hidden z-[1]">
      {shapes.map((shape, index) => (
        <motion.div
          key={index}
          className={`absolute glass rounded-full blur-3xl opacity-[0.08]`}
          style={{
            width: `${shape.size}px`,
            height: `${shape.size}px`,
            left: `${shape.x}%`,
            top: `${shape.y}%`,
            background: `radial-gradient(circle, var(--tw-gradient-stops))`,
            backgroundImage: `radial-gradient(circle, ${
              shape.color === 'vibrant-cyan' ? '#06b6d4' :
              shape.color === 'vibrant-purple' ? '#a855f7' :
              shape.color === 'vibrant-pink' ? '#ec4899' :
              shape.color === 'vibrant-yellow' ? '#fbbf24' :
              '#84cc16'
            }40, transparent 70%)`,
          }}
          animate={{
            scale: [1, 1.3, 1, 0.8, 1],
            x: [0, 50, -30, 30, 0],
            y: [0, -40, 40, -20, 0],
            rotate: [0, 90, 180, 270, 360],
            opacity: [0.08, 0.15, 0.08, 0.12, 0.08],
          }}
          transition={{
            duration: shape.duration,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: shape.delay,
          }}
        />
      ))}
    </div>
  )
}









